import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-website-settings',
  templateUrl: './website-settings.component.html',
  styleUrls: ['./website-settings.component.css']
})
export class WebsiteSettingsComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
